.modal {
  min-width: 480px;
  max-width: min(560px, 96vw);
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  justify-content: space-between;

  input {
    margin: 2px 0 6px 0;
  }
}

.body {
  display: flex !important;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  max-height: min(78vh, 720px) !important;
  overflow-y: auto;
  gap: 8px;
}

.modalHeader {
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  column-gap: 12px;
  font-size: 14px;
  justify-content: space-between;
  width: 100%;
}

.changeOrgNameButtons {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 24px;
  padding-top: 12px;
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: #142f43;
  margin-bottom: 2px;
  display: block;
  padding: 0 12px;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(20, 47, 67, 0.12);

  &:last-of-type {
    border-bottom: none;
  }
}

.sectionTitle {
  font-size: 13px;
  font-weight: 600;
  color: #142f43;
  padding: 4px 12px 0;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  gap: 16px;
}

.switchLabel {
  font-size: 14px;
  font-weight: 500;
  color: #142f43;
}
